// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__p93of","header":"ClearentDisclaimer_header__1yJDi","inner":"ClearentDisclaimer_inner__3RqbV"};